import { useStyles } from './map-feature.style'
import { colors } from '#base/js/variables.style'

export const MapFeature = ({ pathDefinition, color, isSelected, isZoomedIn, className, showOutline = true, enableMouseEvents = true, onMouseOver, onClick }) => {
  const classes = useStyles()
  return (
    <path
      d={pathDefinition}
      fill={color || colors.silver}
      onMouseOver={onMouseOver}
      onClick={onClick}
      className={[
        showOutline ? classes.feature : classes.featureWithoutOutline,
        isSelected ? classes.selected : '',
        enableMouseEvents ? '' : classes.disableMouseEvents,
        isZoomedIn ? classes.zoomedLayer : '',
        className || ''
      ].join(' ').trim()}
    />
  )
}
